import { render, staticRenderFns } from "./coupon-show.vue?vue&type=template&id=d629a530"
import script from "./coupon-show.vue?vue&type=script&lang=js"
export * from "./coupon-show.vue?vue&type=script&lang=js"
import style0 from "./coupon-show.vue?vue&type=style&index=0&id=d629a530&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports